import React, { useState } from "react";

const Composition = (props) => {
  const [data, setData] = useState(props.getData());
  const [selectedText, setSelectedText] = useState("");
  console.log("discharge Summary", data);

  return (
    <div className="observationContainerResource">
      {data.objects.map((item, index) => (
        <div
          key={index}
          className={`${index === data?.objects?.length - 1 ? "lastRow" : ""} ${
            selectedText === index ? "active" : ""
          } cursor-pointer observationItem`}
          onClick={() => {
            props.setResourceListData(item);
            setSelectedText(index);
          }}
        >
          {item?.resource?.type?.text}
        </div>
      ))}
    </div>
  );
};

export default Composition;
